import { render, staticRenderFns } from "./button-spinner.vue?vue&type=template&id=4fe6ef2a&scoped=true&"
import script from "./button-spinner.vue?vue&type=script&lang=js&"
export * from "./button-spinner.vue?vue&type=script&lang=js&"
import style0 from "./button-spinner.vue?vue&type=style&index=0&id=4fe6ef2a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fe6ef2a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/cinderellamaecuya/SP/peppermayo-astro/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4fe6ef2a')) {
      api.createRecord('4fe6ef2a', component.options)
    } else {
      api.reload('4fe6ef2a', component.options)
    }
    module.hot.accept("./button-spinner.vue?vue&type=template&id=4fe6ef2a&scoped=true&", function () {
      api.rerender('4fe6ef2a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/js/components/button-spinner.vue"
export default component.exports